<template>
  <div>
    <section-title
      content="Información General"
      :has-line="true"
      container-class="mt-4 "
    />
    <div class="row mb-3">
      <div class="col-12 col-md-3">
        <div v-if="readOnly" class="mx-1">
          <label class="data-label">Actividad:</label>
          <p>{{ model.activity?.name }}</p>
        </div>
        <validation-provider v-else v-slot="{ errors }" rules="required">
          <custom-drop-down
            id="forAdmission"
            v-model="model.activity"
            label="Actividad:"
            fieldkey="id"
            fieldname="name"
            placeholder="Seleccione"
            :error="errors[0]"
            custom-error-msg="Favor seleccionar una actividad"
            :options="activities"
            :disabled="readOnly"
          />
        </validation-provider>
      </div>
      <div class="col-12 col-md-3">
        <div v-if="readOnly" class="mx-1">
          <label class="data-label">Fecha:</label>
          <p>{{ model.date | date }}</p>
        </div>
        <ValidationProvider
          v-else
          v-slot="{ errors }"
          name="date"
          ref="date"
          rules="required"
        >
          <custom-date-picker
            v-model="model.date"
            required
            label="Fecha:"
            placeholder="DD/MM/YYYY"
            :error="errors[0]"
            custom-error-msg="La fecha es requerida."
            :max-date="currentDate"
            :disabled="readOnly"
          />
        </ValidationProvider>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-12">
        <div v-if="readOnly" class="mx-1">
          <label class="data-label">Describa la actividad realizada:</label>
          <p>{{ model.description }}</p>
        </div>
        <ValidationProvider
          v-else
          v-slot="{ errors }"
          name="reason"
          rules="required"
        >
          <custom-text-area
            v-model="model.description"
            required
            :maxlength="3000"
            label="Describa la actividad realizada:"
            :error="errors[0]"
            :custom-error-msg="'La descripción es requerida'"
            show-char-count
            :count-classes="['d-block', 'small-counter', 'text-right']"
            :disabled="readOnly"
          />
        </ValidationProvider>
      </div>
    </div>
    <div class="row mx-1">
      <div class="col-12">
        <ValidationProvider
          v-slot="{ errors }"
          name="Tipo solicitud"
          rules="required"
        >
          <type-selector
            required
            v-model="model.type"
            :options="typeOptions"
            label="La actividad se realizó para:"
            :error="errors[0]"
            :custom-error-msg="'Debe seleccionar una opción'"
            :disabled="readOnly"
            @input="onTypeChanged()"
          />
        </ValidationProvider>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from "SectionTitle";
import CustomDropDown from "custom-drop-down";
import CustomDatePicker from "custom-date-picker";
import CustomTextArea from "CustomTextArea";
import TypeSelector from "@/components/common/TypeSelector.vue";
import alertMixin from "@quisit/mipe-utils/mixins/alert.mixin.js";

export default {
  name: "GeneralInformation",
  mixins: [alertMixin],
  components: {
    SectionTitle,
    CustomDropDown,
    CustomDatePicker,
    CustomTextArea,
    TypeSelector
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    activities: {
      type: Array,
      default: () => []
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    currentDate: new Date()
  }),
  computed: {
    model: {
      get() {
        return this.value || null;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    typeOptions() {
      return [
        {
          id: 1,
          label: "Estudiante",
          name: "student",
          icon: "fas fa-user"
        },
        {
          id: 2,
          label: "Grupo",
          name: "group",
          icon: "fas fa-users"
        }
      ];
    }
  },
  methods: {
    async onTypeChanged() {
      if (this.readOnly) {
        return;
      }

      const { valid } = await this.$refs.date.validate();
      if (!valid) {
        this.ShowToast(
          "Error",
          `Favor de completar la informacion solicitada`,
          "error"
        );
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
